import { ILoginForm, IUserResponse, IWorker } from 'models';
import { IPrices } from 'models/prices.model';

import { $api, $auth } from '../http';

const _fields = 'acf,id,slug,roles,name,email';

class UserService {
	async login(data: ILoginForm) {
		try {
			const res = await $auth<IUserResponse>('/jwt-auth/v1/token', { data });
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	async getAll(params?: any) {
		try {
			const res = await $api.get<IWorker[]>('/wp/v2/users', { params: { ...params, _fields } });
			return res;
		} catch (error) {
			throw error;
		}
	}

	async update({ id, ...data }: IWorker) {
		try {
			const res = await $api.put<IWorker>(`/wp/v2/users/${id}`, data );
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	async create(data: IWorker) {
		try {
			const res = await $api.post<IWorker>('/wp/v2/users', { ...data, username: data.name.toLocaleLowerCase().replace(/\s+/g, '') });
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	async remove(id: number) {
		try {
			const res = await $api.post<IWorker>(`/myplugin/v1/users/${id}`);
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	async updatePrice(name: keyof IPrices, value: number) {
		try {
			const res = await $api.post<{name: keyof IPrices, value: number }>('/myplugin/v1/update-option', { name, value });
			return res.data;
		} catch (error) {
			throw error;
		}
	}
};

export const userService = new UserService();